import DefaultPageComponent from "./DefaultPageComponent";

const NoNetwork = () => {
  return (
    <DefaultPageComponent
      image="/images/not-found-optimize.gif"
      text=""
      append={
        <div>
          <h3>No Network Connection</h3>
          <p>It looks like you are offline.</p>
          <p>
            Please check your internet connection and try again. Once you are
            back online, refresh the page to continue.
          </p>
        </div>
      }
      svg={NoNetwork}
    />
  );
};
export default NoNetwork;
